import { useMemo } from 'react';

export const useMessages = () =>
  useMemo(
    () => ({
      invalid_grant: 'Invalid user name or password or user is blocked',
      password_expired: 'Your password expired. Please set a new password.',
      user_banned: 'This account is no longer valid. Please sign up with a new account.',
      user_locked: 'Your account is locked for 30 minutes after 5 failed attempts to login.',
    }),
    [],
  );
